// Module
var code = "<amt-datepicker ng-model=\"model\" is-required=\"isRequired\" is-disabled=\"isDisabled\" is-pickonly=\"isPickonly\" mode=\"month\" min-date=\"minDate\" max-date=\"maxDate\" later-then-date=\"laterThenDate\" earlier-then-date=\"earlierThenDate\" is-equal=\"isEqual\"> </amt-datepicker> ";
// Exports
module.exports = code;